import React, { useState, useEffect,useContext } from "react";
import { useLocation } from "react-router-dom";
import Loading from "../../../Reusables/Loader/Loading";
import { Fetch } from "../../../../controllers/controller";
import Row from "./Row";
import NoTransactions from "./NoTransactions";
import AlertComp from "../../../Reusables/AlertComp/AlertComp";
import { getUsertoken, mainGetUsertoken } from "../../Reusables/GetUsertoken/GetUsertoken";
import PaymentModal from "../PaymentModal/PaymentModal";
import WithdrawalModal from "../PaymentModal/WithdrawalModal";
import TransferModal from "../PaymentModal/TransferModal";
import Pdf from "../../../Pdf";
import {WalletContext} from "./WalletContext";
import PayoneerModal from "../PaymentModal/PayoneerModal";
import StripeModal from "../PaymentModal/StripeModal";
import {FiEdit} from "react-icons/fi"
import {FaCheckCircle} from "react-icons/fa";

import { Tabs, Tab, Modal, Button } from "react-bootstrap";
import { PayoneerLogo } from "../../../../Images/svgs";
import payoneer from "../../../../Images/payoneer.png"
import { useMutation } from "react-query";
import { chooseCurrency, getAllCurrencies, getBio } from "../../Super/apis";

const History = () => {
  const [data, setData] = useContext(WalletContext)
  // const value = useContext(WalletContext)
  const location = useLocation();
  const [usertoken, setUsertoken] = useState("");
  const [user, setUser] = useState("");
  const [balance, setBalance] = useState("");
  const [loading, setLoading] = useState(false);
  const [balanceLoad, setBalanceLoad] = useState(false);
  const [rows, setRows] = useState([]);
  const [showAlert, setShowAlert] = useState(false);
  const [alert, setAlertType] = useState({
    type: "",
    value: "",
  });
  // const [showTransfer, setShowTransfer] = useState(false)
  const [showPay, setShowPay] = React.useState(false);
  const [openPayoneer, setOpenPayoneer] = React.useState(false);
  const [openStripe, setOpenStripe] = React.useState(false);
  const [show, setShow] = React.useState(false);
  const [open, setOpen] = React.useState(false);



  const getWalletBalance = () =>{
    if(usertoken !== ""){
      setBalanceLoad(true)

    const formData = new FormData();
    formData.append("apptoken", process.env.REACT_APP_APP_TOKEN);
    formData.append("usertoken", usertoken);

    Fetch(`${process.env.REACT_APP_END_POINT}/wallet-balance`, formData)
      .then((res) => {
        setBalance(res.data.walletbalance);
        setAlertType({
          ...alert,
          type: "success",
          value: res.data.message,
        });
      })
      .catch((err) => {
        setShowAlert(true);
        setAlertType({
          ...alert,
          type: "danger",
          value: err.message,
        });
      }).finally(()=>setBalanceLoad(false))
    }

  }


  function getWalletHistory() {
    if(usertoken !== ""){
      setLoading(true);
   
    let formdata = {
      apptoken: process.env.REACT_APP_APP_TOKEN,
      usertoken: usertoken
    }
    Fetch(`${process.env.REACT_APP_NEND_POINT}/getWalletHistory`, JSON.stringify(formdata))
      .then((res) => {
        if(rows.length > 0 || res.data.success === false){
          return
        } else {
          setRows(res.data?.data);
          setData(res.data?.data)
        }
       
      })
      .catch((err) => {
        setLoading(false);
        setShowAlert(true);
        setAlertType({
          ...alert,
          type: "danger",
          value: err.message,
        });
      }).finally(()=>setLoading(false))
    }

  }



  useEffect(() => {
    mainGetUsertoken(location, setUsertoken, setUser);
  }, []);
  
  useEffect(()=>{
    getWalletHistory();
    getWalletBalance()
    
  },[usertoken])

 
 

  const walletList = [

    {
      
      id:"all",
      keys:"all",
      title:"All",
      element:HistoryTable,
      type:""
      
    },
    {
      
      id:"fund",
      keys:"transfer",
      title:"Fund",
      element:HistoryTable,
      type:"credit"
      
    },
    {
      
      id:"withdraw",
      keys:"withdraw",
      title:"Withdraw",
      element:HistoryTable,
      type:"debit"
      
    },
    {
      
      id:"transfer",
      keys:"transfer",
      title:"Transfer",
      element:HistoryTable,
      type:"debit"
      
    },
    {
      
      id:"settings",
      keys:"settings",
      title:"Settings",
      element:Settings,
      // type:"fund"
      
    },
  ]
  return (
    <main className="pt-4 px-lg-4 px-3" style={{ minHeight: "90vh" }}>
      <header className=" mb-3 d-flex justify-content-between align-items-center flex-wrap dashHeader">
        <h4 className="text-primary title_font">WALLET</h4>
        
      </header>
      <div className="row">
        <WalletBalance loading={balanceLoad} balance={balance} />
        <div className="addtoWallet col-sm-6 "></div>
      </div>
      <Tabs
        defaultActiveKey="all"
        id="uncontrolled-tab-example"
        className="mb-3 title_font"
      >
        {
          walletList.map( ({id, keys, title, element:Element, type}, i) => (
            <Tab eventKey={id} title={title} key={i}> 
              <Element type={type} data={rows} keys={keys} id={id} getWalletHistory={getWalletHistory} />
            </Tab>
          ))
        }
      </Tabs>
      
     
      {/* <PaymentModal show={show} setShow={setShow} />

      <WithdrawalModal
        show={showPay}
        setShow={setShowPay}
        loadHistory={getWalletHistory}
        loadWalBal={getWalletBalance}
      />
      <TransferModal
        open={open}
        setOpen={setOpen}
        loadHistory={getWalletHistory}
        loadWalBal={getWalletBalance}
      />
      <PayoneerModal
        open={openPayoneer}
        setOpen={setOpenPayoneer}
      />
      <StripeModal
        open={openStripe}
        setOpen={setOpenStripe}
      /> */}
    </main>
  );
};

export default History;

function WalletBalance({ balance, loading}){
  

  
  
  return (
    <div className="row">
        <div className="amount col-sm-6 mb-3">
              <div className="d-flex align-items-center g-2">
                <p className="fw-bolder title_font  text-primary me-1">BALANCE: </p>
                <span className="fw-bold title_font  text-primary">
                  {
                    loading ?
                    <span className="spinner-border text-primary">
                      <span className="visually-hidden">loading...</span>
                    </span>
                    :
                    <span>$ {balance}</span>
                  }
                  
                  </span>
              </div>
        </div>
        <div className="addtoWallet col-sm-6 "></div>
      </div>
  )
}
function HistoryTable({type, keys, id, data, getWalletHistory}){

  // const [data, setData] = useContext(WalletContext)
  // const [data, setData] = useState([])
  // const value = useContext(WalletContext)
  const location = useLocation();
  const [usertoken, setUsertoken] = useState("");
  const [user, setUser] = useState("");
  const [loading, setLoading] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [alert, setAlertType] = useState({
    type: "",
    value: "",
  });
  // const [showTransfer, setShowTransfer] = useState(false)
  const [showPay, setShowPay] = React.useState(false);
  const [openPayoneer, setOpenPayoneer] = React.useState(false);
  const [openStripe, setOpenStripe] = React.useState(false);
  const [show, setShow] = React.useState(false);
  const [open, setOpen] = React.useState(false);

  const openModal = (e) => {
    e.preventDefault();
    setShow(true);
  };
  const openWithdrawalModal = (e) => {
    e.preventDefault();
    setShowPay(true);
  };
  const openTransferModal = (e) => {
    e.preventDefault();
    setOpen(true);
  };

  const handleAlertClose = () => {
    setShowAlert(false);
  };
  useEffect(() => {
    getUsertoken(location, setUsertoken, setUser);
  }, []);

   
 

  return (
    <div className="content">
      {
        id &&
        <div className="d-flex justify-content-end flex-wrap mb-3" style={{gap:"5px"}}>
          {
            id === "fund" &&
            <button
              className="btn btn-primary text-white"
              style={{ fontSize: "clamp(14px, 3vw, 18px" }}
              onClick={openModal}
            >
              + 
              Fund Wallet
            </button>
          }
          {
            id === "withdraw" &&
            <button
            className="btn btn-primary text-white"
              style={{ fontSize: "clamp(14px, 3vw, 18px" }}
              onClick={openWithdrawalModal}
            >
              -
              Withdraw
            </button>
          }
          {
            id === "transfer" && 
              <button
              className="btn btn-primary text-white"
                style={{ fontSize: "clamp(14px, 3vw, 18px" }}
                onClick={openTransferModal}
              >
              - Transfer
              </button>
          }
           
          </div>
        
      }
        {showAlert === true && (
          <AlertComp
            variant={alert.type}
            alertText={alert.value}
            handleAlertClose={handleAlertClose}
          />
        )}
        {loading ? (

          <div className="spinner-border text-primary mx-auto">
            <div className="visually-hidden">Loading...</div>
          </div>
        ) : (
          <div className="table-responsive">
            {data?.length > 0 ? (
              <>
              <table className="table table-bordered table-striped">
                <thead className="thead-dark">
                  <tr>
                    <th>S/N</th>
                    <th>TIME</th>
                    <th>TYPE</th>
                    <th>AMOUNT</th>
                    <th>SOURCE</th>
                    <th>LOG</th>
                  </tr>
                </thead>
                <tbody>
                  {
                  type === "" ?
                    data?.map((row) => (
                      <Row
                        {...row}
                      />
                    ))
                    :
                    data?.filter(item=>(
                      item.tab === keys?.toLowerCase() && item.type === type
                      
                      )).map((row) => (
                    <Row
                      {...row}
                    />
                  ))
                }
                </tbody>
              </table>
              <Pdf name={data[0]?.fullName} data={data} />
              {/* pdf component */}
              
              </>

            ) : (
              <NoTransactions />
            )}
          </div>
        )}

    <PaymentModal show={show} setShow={setShow} />

    <WithdrawalModal
      show={showPay}
      setShow={setShowPay}
      loadHistory={getWalletHistory}
      // loadWalBal={getWalletBalance}
    />
    <TransferModal
      open={open}
      setOpen={setOpen}
      loadHistory={getWalletHistory}
      // loadWalBal={getWalletBalance}
    />
    <PayoneerModal
      open={openPayoneer}
      setOpen={setOpenPayoneer}
    />
    <StripeModal
      open={openStripe}
      setOpen={setOpenStripe}
      usertoken={usertoken}

    />
      </div>
  )
}

function Settings({handleStripe, handlePayoneer}){
  const [showCurrency, setShowCurrency] = useState(false)
  const [openModal, setOpenModal] = useState(false)
  const [openCurrencyModal, setOpenCurrencyModal] = useState(false)
  const [openPayoneer, setOpenPayoneer] = React.useState(false);
  const [openStripe, setOpenStripe] = React.useState(false);
  const location = useLocation();
  const [usertoken, setUsertoken] = useState("")
  const [user, setUser] = useState("")
  const [data, setData]= useState({})

  function handleRemove(){
    setOpenModal(false)
  }

  function handleCurrencyModalRemove(){
    setOpenCurrencyModal(false)
  }

  function openpayoneer(){
    setOpenPayoneer(true)
  }
  function openstripe(){
    setOpenStripe(true)
  }


  const getUserdetails = useMutation(getBio, {
    onSuccess: (res)=>{
      console.log(res)
      if(res.data.success){
        setData(res.data)
        return
      }
    },
    onError: err=>console.error(err)
  })
  

  useEffect(() => {
    mainGetUsertoken(location, setUsertoken,setUser)
  }, [])

  useEffect(() => { 
    if(usertoken){
      getUserdetails.mutate({
        apptoken:process.env.REACT_APP_APP_TOKEN,usertoken
      })
    }
  }, [usertoken])
  
  return (
    <div className="container wallet_history">
      <div className="row">
        <div className="col-12 p-1 d-flex" style={{gap:"2rem"}}>
          <h5 className="my-4 text-dark text_font">Currency</h5>
          <div className="my-4 text-dark d-flex flex-column ">
            <button onClick={(e)=>{
              e.preventDefault();
              setOpenCurrencyModal(true);
            }} style={{border:"none", outline:"none", background:"inherit"}}>
              {data?.currency} <FiEdit  size="10px" />
            </button>
            {
              showCurrency &&

              <div className="mt-4">
                <label htmlFor="currency" className="visually-hidden">Select Preferred Currency</label>
                <select name="currency" id="currency" className="form-select">
                  <option value="USD">USD</option>
                  <option value="AED">AED</option>
                </select>
              </div>
            }
          </div>
          
        </div>
        <div className="col-12 p-1  d-flex" style={{gap:"2rem"}}>
        <h5 className="my-4 text-dark text_font">Payment Options</h5>
          <div className="my-4 text-dark">
            <p className="text-primary text_font" onClick={()=>setOpenModal(true)} style={{cursor: "pointer"}}>Select and link your wallet to our partner payment processors</p>
          </div>
        </div>
      </div>
      <PaymentOption openModal={openModal} handleRemove={handleRemove} handleStripe={openstripe} handlePayoneer={openpayoneer} data={data} />
      <PayoneerModal
      open={openPayoneer}
      setOpen={setOpenPayoneer}
    />
    <StripeModal
      open={openStripe}
      setOpen={setOpenStripe}
      usertoken={usertoken}
    />
    <CurrencyOption  openModal={openCurrencyModal} handleRemove={handleCurrencyModalRemove}  />
    </div>

  )
}

function PaymentOption({openModal, handleRemove, handleStripe, handlePayoneer, data}){

  return(
    <Modal show={openModal} onHide={handleRemove} dialogClassName="history_modal" >
      <Modal.Body className="">
        <header className="mb-5">
          <h4 className="text-primary title_font">Payment Options</h4>
        </header>
          <div className="d-flex payment_options">
            <div className="payment__types">
              <div>
                <img src={payoneer} alt="payoneer" style={{height:"65px", width:"150px", }} />
              </div>
              <div><PaypalLogo /></div>
              <div><StripeLogo /></div>
            </div>
            <div className="bar"></div>
            <div className="payment__details">
              <div onClick={handlePayoneer} style={{cursor: "pointer", paddingTop:"1rem"}}>{
                data?.payoneer_linked === "0" || !data?.payoneer_linked ? 
                <span style={{fontSize: "14px"}}>Payoneer account is your key to unlock a universe of opportunities. Whether making international payments, receiving funds, managing your digital business, or accessing capital, Payoneer opens your business up to the world.</span>
                :
                <div className="d-flex align-items-center gap-3" >
                  <FaCheckCircle color="green" size="1.3rem" />
                  <span style={{fontSize: "1.3rem"}}>Connected</span>
                </div>
              }</div>
              <div style={{cursor: "pointer", paddingTop:"1rem"}}>
                {
                  data?.paypal_linked === "0" || !data?.paypal_linked ?
                  <span style={{fontSize: "14px"}}>Paypal is the safer, easier way to pay and get paid online. The service allows anyone to pay in any way they prefer</span>
                  :
                  <div className="d-flex align-items-center gap-3" >
                    <FaCheckCircle color="green" size="1.3rem" />
                    <span style={{fontSize: "1.3rem"}}>Connected</span>
                  </div>
                }
              </div>
              <div onClick={handleStripe} style={{cursor: "pointer", paddingTop:"1rem"}}>


                {
                  data?.stripe_linked === "0" || !data?.stripe_linked ?
                  <span style={{fontSize: "14px"}}>Strip,Inc.  is an Irish-American financial services and software as a service company</span>
                  :
                  <div className="d-flex align-items-center gap-3" >
                    <FaCheckCircle color="green" size="1.3rem" />
                    <span style={{fontSize: "1.3rem"}}>Connected</span>
                  </div>
                }
              </div>
              
            </div>
          </div>

      </Modal.Body> 
      <Modal.Footer>
        <Button variant="secondary" onClick={handleRemove}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
function CurrencyOption({openModal, handleRemove}){
  const location = useLocation();
  const [formstate, setFormstate] = useState({})
  const [usertoken, setUsertoken] = useState("")
  const [user, setUser] = useState("")
  const [data, setData] = useState([])
  const [showAlert, setShowAlert] = useState(false);
  const [alert, setAlertType] = useState({
    type: "",
    value: "",
  });


  useEffect(() => {
    mainGetUsertoken(location, setUsertoken, setUser)
  
  },[])



  function handleChange(e){
    setFormstate({...formstate, [e.target.name]: e.target.value})
  }



  const getCurrencies = useMutation(getAllCurrencies, {
    onSuccess: res=>{
      console.log(res)
      if(res?.data?.length > 0){
        setData(res.data)
      }else {
        setData([])
      }
    },
    onError: err=>{
      console.error(err)
    }
  })



  useEffect(() => {
    getCurrencies.mutate({})
  }, [usertoken])



  const updateCurrency = useMutation(chooseCurrency, {
    onSuccess: res=>{
      console.log({res})
      setShowAlert(true)
      if(res.data.success){
        setAlertType({
          type:"success",
          value: res.data.message
        })
        return
      }
      setAlertType({
        type:"danger",
        value: res.data.message
      })
    
    },
    onError: err=>{
      setShowAlert(true)
      setAlertType({
        type:"danger",
        value: err.message
      })
      console.error(err)
    }
  })



  function submit(e){
    e.preventDefault();
    updateCurrency.mutate({...formstate, usertoken})
  }



  const handleAlertClose = () => {
    setShowAlert(false);
  };



  return(
    <Modal show={openModal} onHide={handleRemove} >
      <Modal.Body className="">
        <header className="mb-5">
          <h4 className="title_font">Currency Options</h4>
        </header>
        {showAlert === true && (
          <AlertComp
            variant={alert.type}
            alertText={alert.value}
            handleAlertClose={handleAlertClose}
          />
        )}
          <div className="d-flex justify-content-center">
            <div className="mt-4">
              <div className="form-group">
                <label htmlFor="currency" className="">Select Preferred Currency</label>
                <select name="currency" id="currency" className="form-select" value={formstate.currency} onChange={handleChange} >
                  <option value="" defaultValue>Select currency</option>
                  {
                    data.map(item=>(
                      <option value={item.id}>{item.acronym}</option>
                    ))
                  }
                </select>
              </div>
              {/* <div className="form-group my-3">
                <label htmlFor="type" className="">Type</label>
                <select name="type" id="type" className="form-select" value={formstate.type} onChange={handleChange} >
                  <option value="FUND">Fund</option>
                  <option value="WITHDRAW">Withdraw</option>
                  <option value="TRANSFER">Transfer</option>
                  <option value="ALL">All</option>
                </select>
              </div> */}
                  <button className="btn btn-primary my-3" onClick={submit} disabled={updateCurrency.isLoading}>
                    {
                      updateCurrency.isLoading ?

                      <div className="spinner-border text-white">
                        <div className="visually-hidden">Loading...</div>
                      </div>
                      :
                      <span>Save</span>
                    }
                  </button>
              </div>
              
          </div>

      </Modal.Body> 
    </Modal>
  )
}

function StripeLogo(){
  return (
    <svg width="100" height="55" viewBox="0 0 512 214" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid"><path d="M35.982 83.484c0-5.546 4.551-7.68 12.09-7.68 10.808 0 24.461 3.272 35.27 9.103V51.484c-11.804-4.693-23.466-6.542-35.27-6.542C19.2 44.942 0 60.018 0 85.192c0 39.252 54.044 32.995 54.044 49.92 0 6.541-5.688 8.675-13.653 8.675-11.804 0-26.88-4.836-38.827-11.378v33.849c13.227 5.689 26.596 8.106 38.827 8.106 29.582 0 49.92-14.648 49.92-40.106-.142-42.382-54.329-34.845-54.329-50.774zm96.142-66.986l-34.702 7.395-.142 113.92c0 21.05 15.787 36.551 36.836 36.551 11.662 0 20.195-2.133 24.888-4.693V140.8c-4.55 1.849-27.022 8.391-27.022-12.658V77.653h27.022V47.36h-27.022l.142-30.862zm71.112 41.386L200.96 47.36h-30.72v124.444h35.556V87.467c8.39-10.951 22.613-8.96 27.022-7.396V47.36c-4.551-1.707-21.191-4.836-29.582 10.524zm38.257-10.524h35.698v124.444h-35.698V47.36zm0-10.809l35.698-7.68V0l-35.698 7.538V36.55zm109.938 8.391c-13.938 0-22.898 6.542-27.875 11.094l-1.85-8.818h-31.288v165.83l35.555-7.537.143-40.249c5.12 3.698 12.657 8.96 25.173 8.96 25.458 0 48.64-20.48 48.64-65.564-.142-41.245-23.609-63.716-48.498-63.716zm-8.533 97.991c-8.391 0-13.37-2.986-16.782-6.684l-.143-52.765c3.698-4.124 8.818-6.968 16.925-6.968 12.942 0 21.902 14.506 21.902 33.137 0 19.058-8.818 33.28-21.902 33.28zM512 110.08c0-36.409-17.636-65.138-51.342-65.138-33.85 0-54.33 28.73-54.33 64.854 0 42.808 24.179 64.426 58.88 64.426 16.925 0 29.725-3.84 39.396-9.244v-28.445c-9.67 4.836-20.764 7.823-34.844 7.823-13.796 0-26.027-4.836-27.591-21.618h69.547c0-1.85.284-9.245.284-12.658zm-70.258-13.511c0-16.071 9.814-22.756 18.774-22.756 8.675 0 17.92 6.685 17.92 22.756h-36.694z" fill="#6772E5"/></svg>
  )
}
function PaypalLogo(){
  return (
    <svg height="55" viewBox="-.02682843 0 123.63183286 30.17842908" width="150" xmlns="http://www.w3.org/2000/svg"><path d="m46.211 6.749h-6.839a.95.95 0 0 0 -.939.802l-2.766 17.537a.57.57 0 0 0 .564.658h3.265a.95.95 0 0 0 .939-.803l.746-4.73a.95.95 0 0 1 .938-.803h2.165c4.505 0 7.105-2.18 7.784-6.5.306-1.89.013-3.375-.872-4.415-.972-1.142-2.696-1.746-4.985-1.746zm.789 6.405c-.374 2.454-2.249 2.454-4.062 2.454h-1.032l.724-4.583a.57.57 0 0 1 .563-.481h.473c1.235 0 2.4 0 3.002.704.359.42.469 1.044.332 1.906zm19.654-.079h-3.275a.57.57 0 0 0 -.563.481l-.145.916-.229-.332c-.709-1.029-2.29-1.373-3.868-1.373-3.619 0-6.71 2.741-7.312 6.586-.313 1.918.132 3.752 1.22 5.031.998 1.176 2.426 1.666 4.125 1.666 2.916 0 4.533-1.875 4.533-1.875l-.146.91a.57.57 0 0 0 .562.66h2.95a.95.95 0 0 0 .939-.803l1.77-11.209a.568.568 0 0 0 -.561-.658zm-4.565 6.374c-.316 1.871-1.801 3.127-3.695 3.127-.951 0-1.711-.305-2.199-.883-.484-.574-.668-1.391-.514-2.301.295-1.855 1.805-3.152 3.67-3.152.93 0 1.686.309 2.184.892.499.589.697 1.411.554 2.317zm22.007-6.374h-3.291a.954.954 0 0 0 -.787.417l-4.539 6.686-1.924-6.425a.953.953 0 0 0 -.912-.678h-3.234a.57.57 0 0 0 -.541.754l3.625 10.638-3.408 4.811a.57.57 0 0 0 .465.9h3.287a.949.949 0 0 0 .781-.408l10.946-15.8a.57.57 0 0 0 -.468-.895z" fill="#253b80"/><path d="m94.992 6.749h-6.84a.95.95 0 0 0 -.938.802l-2.766 17.537a.569.569 0 0 0 .562.658h3.51a.665.665 0 0 0 .656-.562l.785-4.971a.95.95 0 0 1 .938-.803h2.164c4.506 0 7.105-2.18 7.785-6.5.307-1.89.012-3.375-.873-4.415-.971-1.142-2.694-1.746-4.983-1.746zm.789 6.405c-.373 2.454-2.248 2.454-4.062 2.454h-1.031l.725-4.583a.568.568 0 0 1 .562-.481h.473c1.234 0 2.4 0 3.002.704.359.42.468 1.044.331 1.906zm19.653-.079h-3.273a.567.567 0 0 0 -.562.481l-.145.916-.23-.332c-.709-1.029-2.289-1.373-3.867-1.373-3.619 0-6.709 2.741-7.311 6.586-.312 1.918.131 3.752 1.219 5.031 1 1.176 2.426 1.666 4.125 1.666 2.916 0 4.533-1.875 4.533-1.875l-.146.91a.57.57 0 0 0 .564.66h2.949a.95.95 0 0 0 .938-.803l1.771-11.209a.571.571 0 0 0 -.565-.658zm-4.565 6.374c-.314 1.871-1.801 3.127-3.695 3.127-.949 0-1.711-.305-2.199-.883-.484-.574-.666-1.391-.514-2.301.297-1.855 1.805-3.152 3.67-3.152.93 0 1.686.309 2.184.892.501.589.699 1.411.554 2.317zm8.426-12.219-2.807 17.858a.569.569 0 0 0 .562.658h2.822c.469 0 .867-.34.939-.803l2.768-17.536a.57.57 0 0 0 -.562-.659h-3.16a.571.571 0 0 0 -.562.482z" fill="#179bd7"/><path d="m7.266 29.154.523-3.322-1.165-.027h-5.563l3.866-24.513a.316.316 0 0 1 .314-.268h9.38c3.114 0 5.263.648 6.385 1.927.526.6.861 1.227 1.023 1.917.17.724.173 1.589.007 2.644l-.012.077v.676l.526.298a3.69 3.69 0 0 1 1.065.812c.45.513.741 1.165.864 1.938.127.795.085 1.741-.123 2.812-.24 1.232-.628 2.305-1.152 3.183a6.547 6.547 0 0 1 -1.825 2c-.696.494-1.523.869-2.458 1.109-.906.236-1.939.355-3.072.355h-.73c-.522 0-1.029.188-1.427.525a2.21 2.21 0 0 0 -.744 1.328l-.055.299-.924 5.855-.042.215c-.011.068-.03.102-.058.125a.155.155 0 0 1 -.096.035z" fill="#253b80"/><path d="m23.048 7.667c-.028.179-.06.362-.096.55-1.237 6.351-5.469 8.545-10.874 8.545h-2.752c-.661 0-1.218.48-1.321 1.132l-1.409 8.936-.399 2.533a.704.704 0 0 0 .695.814h4.881c.578 0 1.069-.42 1.16-.99l.048-.248.919-5.832.059-.32c.09-.572.582-.992 1.16-.992h.73c4.729 0 8.431-1.92 9.513-7.476.452-2.321.218-4.259-.978-5.622a4.667 4.667 0 0 0 -1.336-1.03z" fill="#179bd7"/><path d="m21.754 7.151a9.757 9.757 0 0 0 -1.203-.267 15.284 15.284 0 0 0 -2.426-.177h-7.352a1.172 1.172 0 0 0 -1.159.992l-1.564 9.906-.045.289a1.336 1.336 0 0 1 1.321-1.132h2.752c5.405 0 9.637-2.195 10.874-8.545.037-.188.068-.371.096-.55a6.594 6.594 0 0 0 -1.017-.429 9.045 9.045 0 0 0 -.277-.087z" fill="#222d65"/><path d="m9.614 7.699a1.169 1.169 0 0 1 1.159-.991h7.352c.871 0 1.684.057 2.426.177a9.757 9.757 0 0 1 1.481.353c.365.121.704.264 1.017.429.368-2.347-.003-3.945-1.272-5.392-1.399-1.593-3.924-2.275-7.155-2.275h-9.38c-.66 0-1.223.48-1.325 1.133l-3.907 24.765a.806.806 0 0 0 .795.932h5.791l1.454-9.225z" fill="#253b80"/></svg>
  )
}